<mat-toolbar class="er-header">
  <a class="er-brand" routerLink="/dashboard" aria-label="EasyRin dashboard">
    <span class="er-brand-mark"><img src="assets/easyrin/easyrin-glyph.webp" alt="EasyRin logo"></span>
    <span class="er-brand-text">
      <span class="er-brand-wm">Easy<span class="er-brand-rin">Rin</span></span>
      <span class="er-brand-sub">Retailer portal</span>
    </span>
  </a>

  <span class="er-spacer"></span>

  <div class="er-wallet-chip" *ngIf="walletAmount">
    <span class="er-wallet-block" routerLink="/recharge-wallet">
      <span class="er-wallet-label">Wallet balance</span>
      <span class="er-wallet-value">{{ walletAmount.balance | erInr }}</span>
    </span>
    <span class="material-icons er-wallet-chip-refresh" (click)='updateWallet()' title="Refresh balance">refresh</span>
  </div>

  <div class="er-id-chip">
    <span class="er-id-name">{{currentUserDetails2}}</span>
    <span class="er-id-meta">{{uniqueId}} · Parent {{retailorParentDistributorUniqueName}}</span>
  </div>

  <a class="er-bell" routerLink="/notifications" (click)="getRetailerNotifications()" title="Notifications">
    <span class="material-icons er-bell-ico">notifications</span>
    <span class="er-badge">{{getRetailerNotificationsCount?getRetailerNotificationsCount:0}}</span>
  </a>

  <div class="logout-btn">
    <a mat-button class="er-logout" (click)="onLogout()">Logout</a>
  </div>
  <span class="material-icons logout-icon er-logout-icon" (click)="onLogout()">
    logout
  </span>
</mat-toolbar>
<div class="er-alert-row" *ngIf="alertMessage">
  <span class="er-alert-tag">Alert</span>
  <marquee class="er-alert-marquee">{{alertMessage}}</marquee>
</div>
